import React, { ReactNode, useState } from 'react';
import { KeyframeIndex, ParsedShaderSet, PropertyKeyframeSet, PropIndex, ShaderId } from './parser/parser';
import { PropertyValue } from './parser/propTypes';
import SelectedShadersEditor from './SelectedShadersEditor';
import ShaderPropsEditor from './ShaderPropsEditor';

export interface PropsSidebarProps {
  parsedShaders: ParsedShaderSet;
  activeShaders: ShaderId[];
  setActiveShaders: (shaders: ShaderId[]) => void;

  shaderProps: PropertyValue[][];
  shaderPropKeyframes: PropertyKeyframeSet;
  setShaderProp: (shader: ShaderId, propIndex: number, val: PropertyValue) => void;

  activeKeyframe: KeyframeIndex | null;
  addKeyframe: (prop: [ShaderId, PropIndex]) => void;
  deleteActiveKeyframe: () => void;

  onPopupWindow: (contents: ReactNode) => void;
  // enable / disable animation controls
  doAnimate: boolean;
  setDoAnimate: React.Dispatch<React.SetStateAction<boolean>>;
}

enum SidebarMode {
  // display pipeline editor
  SelectedShaders = 0,
  // display properties editor
  ShaderProps = 1
};

// A sidebar that allows the user to switch between the SelectedShaderEditor and ShaderPropsEditor
export default function PropsSidebar(props: PropsSidebarProps) {
  const { parsedShaders, activeShaders, shaderProps, shaderPropKeyframes, setShaderProp, setActiveShaders, activeKeyframe, addKeyframe, deleteActiveKeyframe, onPopupWindow, doAnimate, setDoAnimate } = props;

  const [ mode, setMode ] = useState<SidebarMode>(SidebarMode.SelectedShaders);

  return (
    <>
      <div className="sidebarMode">
        <div 
          className={`sidebarModeSelectedShaders ${mode === SidebarMode.SelectedShaders ? "sidebarModeActive" : "sidebarModeInactive"}`}
          onClick={() => {
            setMode(SidebarMode.SelectedShaders);
          }}
        >
          Pipeline
        </div>
        <div 
          className={`sidebarModeShaderProps ${mode === SidebarMode.ShaderProps ? "sidebarModeActive" : "sidebarModeInactive"}`}
          onClick={() => {
            setMode(SidebarMode.ShaderProps);
          }}
        >
          Properties
        </div>
      </div>
      <div className="propsSidebarBody">
        {mode === SidebarMode.SelectedShaders &&
          <SelectedShadersEditor
            activeShaders={activeShaders}
            parsedShaders={parsedShaders}
            setActiveShaders={setActiveShaders}
            onPopupWindow={onPopupWindow}
          ></SelectedShadersEditor>
        }
        {mode === SidebarMode.ShaderProps &&
          <ShaderPropsEditor
            activeShaders={activeShaders}
            parsedShaders={parsedShaders}
            setShaderProp={setShaderProp}
            shaderProps={shaderProps}
            shaderPropKeyframes={shaderPropKeyframes}
            activeKeyframe={activeKeyframe}
            addKeyframe={addKeyframe}
            deleteActiveKeyframe={deleteActiveKeyframe}
            onPopupWindow={onPopupWindow}
            doAnimate={doAnimate}
            setDoAnimate={setDoAnimate}
          ></ShaderPropsEditor>
        }
      </div>
    </>
  )
}